import React, { Component } from "react";
import { GrBarChart, GrConfigure, GrOptimize, GrMoney } from "react-icons/gr";
import Title from "./Title";
export default class Services extends Component {
  state = {
    services: [
      {
        icon: <GrBarChart />,
        title: "Market Evaluation Business Assessment",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?"
      },
      {
        icon: <GrConfigure />,
        title: "Small Business Advisory Services",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?"
      },
      {
        icon: <GrOptimize />,
        title: "Small Business Valuation",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?"
      },
      {
        icon: <GrMoney />,
        title: "Private Business Listings",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?"
      }
    ]
  };
  render() {
    return (
      <section className="services">
        <Title title="services" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
